import { render, staticRenderFns } from "./AppPanelCollapseSmall.vue?vue&type=template&id=6007fa1f&scoped=true&"
import script from "./AppPanelCollapseSmall.vue?vue&type=script&lang=js&"
export * from "./AppPanelCollapseSmall.vue?vue&type=script&lang=js&"
import style0 from "./AppPanelCollapseSmall.vue?vue&type=style&index=0&id=6007fa1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007fa1f",
  null
  
)

export default component.exports